var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { browserClient } from '@no0dles/hsr-browser/browser-client';
export function rpcBrowserClient(url) {
    const client = browserClient(url);
    return {
        call(name, arg) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = yield client.body(JSON.stringify(arg)).post(`/api/rpc/${name}`);
                if (result.statusCode === 200) {
                    return result.bodyAsJson();
                }
                else {
                    throw new Error(`rpc call ${name} failed`);
                }
            });
        },
    };
}
